/** Explicit identities: KR ordinary shares and US ADRs never share drawings. */
const US=new Set(['IXIC','NDX','LITE','SKHY','SNDK','NVDA','AMD','AVGO','MU','TSM','MSFT','GOOGL','AMZN','META','QQQ']);
const KR=new Set(['000660','005930']);
export function worldSymbol(input:string):string|null {
 const s=input.trim().toUpperCase();
 const metal=s.replace(/^FX:/,'').replace('/','');
 if(['XAUUSD','XAU'].includes(metal))return 'fx:XAUUSD';
 if(['XAGUSD','XAG'].includes(metal))return 'fx:XAGUSD';
 const kr=/^(?:KR:|KRX:)(\d{6})$/.exec(s)??/^(\d{6})\.KS$/.exec(s);
 if(kr)return KR.has(kr[1])?`kr:${kr[1]}`:null;
 const code=s.replace(/^(US:|NASDAQ:|NYSE:|\^)/,'');
 return US.has(code)?`us:${code}`:null;
}

export const chartPriceDigits=(symbol:string)=>worldSymbol(symbol)?.startsWith('fx:')?3:2;
